import axios from '../../apis/apicidtech';
import { types } from '../../types/types';
import { getToken } from '../../utils/tokencidtechapi';
import { dispatchpending, dispatchresponse, dispatchresponseerror } from '../utils/dispatches';

export const novoatualiza = (dados = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.put('termos/novoatualiza',
                {
                    ...dados
                },
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data,types.TERMOS.NOVOATUALIZA);

            return response.data;

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const pesquisa = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.get('termos/pesquisa',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data?response.data:{},types.TERMOS.PESQUISA);

            return response.data?response.data:{};

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const pesquisaEmailRenderiza = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('credenciais/credencial/email/renderizar',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data?response.data:{},types.TERMOS.RENDERIZAR);

            return response.data?response.data:{};

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const pesquisaTipos = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('termos/tipos/pesquisa',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data?response.data:{},types.TERMOS.PESQUISATIPOS);

            return response.data?response.data:{};

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}